import { AppShell } from '@/components/layout/AppShell';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function LawyerFinanceiro() {
  // TODO(parecer-mvp): receita mensal/total, próximos saques, histórico de pagamentos — Phase 4
  return (
    <AppShell role="lawyers">
      <div className="max-w-4xl">
        <h1 className="font-serif text-display-lg">Financeiro</h1>
        <p className="text-muted-foreground mt-2">Receitas, saques e histórico de pagamentos.</p>
        <Card className="mt-8">
          <CardHeader>
            <CardTitle>Sem movimentação</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Após sua primeira tarefa concluída, a receita aparecerá aqui. Saques via PIX em até 1 dia útil. Habilita na Fase 4 do roadmap.
            </p>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
